"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_BOOTSTRAP_REQUEST_FAIL = exports.FETCH_BOOTSTRAP_REQUEST_CANCEL = exports.FETCH_BOOTSTRAP_REQUEST_SUCCESS = exports.FETCH_BOOTSTRAP_REQUEST = void 0;
exports.FETCH_BOOTSTRAP_REQUEST = '@BOOTSTRAP/FETCH_BOOTSTRAP_REQUEST';
exports.FETCH_BOOTSTRAP_REQUEST_SUCCESS = '@BOOTSTRAP/FETCH_BOOTSTRAP_REQUEST_SUCCESS';
exports.FETCH_BOOTSTRAP_REQUEST_CANCEL = '@BOOTSTRAP/FETCH_BOOTSTRAP_REQUEST_CANCEL';
exports.FETCH_BOOTSTRAP_REQUEST_FAIL = '@BOOTSTRAP/FETCH_BOOTSTRAP_REQUEST_FAIL';